exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-filters-padding > div {\n    margin-top: .5rem;\n}\n", ""]);

// exports
